import { render, staticRenderFns } from "./teacherView.vue?vue&type=template&id=f315c934&"
import script from "./teacherView.vue?vue&type=script&lang=js&"
export * from "./teacherView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports